import { render, staticRenderFns } from "./SoleProprietorshipMoreResults.vue?vue&type=template&id=4286527d&scoped=true"
import script from "./SoleProprietorshipMoreResults.vue?vue&type=script&lang=js"
export * from "./SoleProprietorshipMoreResults.vue?vue&type=script&lang=js"
import style0 from "./SoleProprietorshipMoreResults.vue?vue&type=style&index=0&id=4286527d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4286527d",
  null
  
)

export default component.exports